import { Button, ModalAlert, Spinner } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { formatDate } from "@mixitone/util";
import RatingTooltip from "components/common/RatingTooltip";
import ClubPlayerFormController from "./ClubPlayerFormController";
import Form from "./Form";
import { ModalFormFieldset } from "./FormRenderers/ModalFormRenderer";

const FieldSet = ApplicationView(() => {
  const controller = ClubPlayerFormController.use();
  return <ModalFormFieldset fields={Object.values(controller.fields())} />;
});

const ClubPlayerForm: React.FC = () => {
  const controller = ClubPlayerFormController.use();
  const { saving, loading, newRecord, sessionCount, lastSession, club, showDeleteTokenModal } =
    controller.state;
  const { search, canCancel } = controller.props;

  if (loading) return <Spinner size={64} />;

  const { canDelete } = controller;
  const showSearch = search && newRecord;
  const disabled = saving || !club.hasManagePermission();

  return (
    <>
      <Form name="player">
        <FieldSet />

        {!search && !newRecord && (
          <div className="mb-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Sessions:</h3>
              <p>{sessionCount}</p>
            </div>
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Last session:</h3>
              <p>{lastSession ? formatDate(lastSession) : "N/A"}</p>
            </div>
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-1 text-sm font-medium">
                <span>Rating:</span>
                <RatingTooltip />
              </h3>
              <p>{controller.state.record.ratingOrDefault}</p>
            </div>
          </div>
        )}

        <div className="flex items-center justify-end gap-2">
          {canDelete && (
            <Button type="button" kind="danger" disabled={saving} onClick={() => controller.actionDelete()}>
              Delete
            </Button>
          )}
          <Button type="submit" disabled={disabled} spinner={saving}>
            {showSearch && "Create"}
            {!showSearch && "Save"}
          </Button>
          {canCancel && (
            <Button type="button" kind="plain" onClick={() => controller.actionCancel()}>
              Cancel
            </Button>
          )}
        </div>
      </Form>
      {showDeleteTokenModal && (
        <ModalAlert
          title="Delete token"
          message="Are you sure you want to delete this token?"
          onConfirm={() => controller.actionConfirmDeleteToken()}
          onCancel={() => controller.actionCancelDeleteToken()}
          confirmText="Yes, delete"
          cancelText="No"
          loading={saving}
        />
      )}
    </>
  );
};

export default ClubPlayerFormController.scope(ApplicationView(ClubPlayerForm));
